var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BarChart',{staticClass:"c-meters-kpi-chart",attrs:{"chart-data":_vm.processedChartData,"options":_vm.options,"exportable":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }